<template>
    <a-modal title="房源信息" :visible="is_modal_house" centered @cancel="house_cancel" @ok="house_ok">
      <a-form-model :model="form_house" :rules="is_modalrules" ref="form_house">
        <a-form-model-item label="姓名" prop="lessorsName">
          <a-input v-model="form_house.lessorsName" />
        </a-form-model-item>
        <a-form-model-item label="电话" prop="lessorsPhone">
          <a-input v-model="form_house.lessorsPhone" />
        </a-form-model-item>
        <a-form-model-item label="身份证/统一社会编码" prop="lessorCardNo">
          <a-input v-model="form_house.lessorCardNo" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
</template>

<script>
import {
  edit_contractLessor
} from '@/api/system/contract'
export default {
    data () {
        // 电话号码正则
        const validatePhone = async (rule, value, callback) => {
            const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
            if (value === undefined || value === '') {
                callback()
            } else if (!reg.test(value)) {
                callback(new Error('请输入正确格式的手机号码!'))
            } else {
                callback()
            }
        }
        return {
            is_modal_house: false,
            form_house: {
                id: 0,
                lessorCardNo: '',
                lessorsName: '',
                lessorsPhone: ''
            },
            is_modalrules: {
                lessorsName: [
                    { required: true, message: '姓名不能为空', trigger: 'blur' },
                    { min: 1, max: 7, message: '长度2-7位', trigger: 'blur' }
                ],
                lessorsPhone: [
                    { required: true, message: '电话不能为空', trigger: 'blur' },
                    { validator: validatePhone, trigger: 'blur' }
                ],
                lessorCardNo: [{ required: true, message: '证件号码不能为空', trigger: 'blur' }],
               
            }
        }
    },
    methods: {
         // 取消-关闭---客
        house_cancel () {
            this.$refs.form_house.resetFields()
            this.is_modal_house = false
        },
        // 提交---客
        house_ok () {
            this.$refs.form_house.validate((valid) => {
                if (valid) {
                    edit_contractLessor(this.form_house).then((res) => {
                        if (res.code === 200) {
                            this.$message.success('修改成功')
                            this.$emit('onSuccess')
                            this.house_cancel()
                        }
                    })
                } else {
                    return false
                }
            })
        },
    }
}
</script>

<style lang="less" scoped>

</style>